export const FETCH_EPG_CHANNELS_INIT = 'FETCH_EPG_CHANNELS_INIT';
export const FETCH_EPG_CHANNELS_SUCCESS = 'FETCH_EPG_CHANNELS_SUCCESS';
export const FETCH_EPG_CHANNELS_ERROR = 'FETCH_EPG_CHANNELS_ERROR';
